import { Order } from '@gelatonetwork/limit-orders-lib'

export enum ORDER_CATEGORY {
  Open = 0,
  History = 1,
}

export enum LimitOrderStatus {
  OPEN = 'open',
  CANCELLED = 'cancelled',
  EXECUTED = 'executed',
}

export enum Field {
  INPUT = 'input',
  OUTPUT = 'output',
  PRICE = 'price',
}

export enum Rate {
  MUL = 'mul',
  DIV = 'div',
}

export interface OrderState {
  readonly independentField: Field
  readonly basisField: Field
  readonly typedValue: string
  readonly inputValue?: string
  readonly outputValue?: string
  readonly [Field.INPUT]: {
    readonly currencyId: string | undefined
  }
  readonly [Field.OUTPUT]: {
    readonly currencyId: string | undefined
  }

  readonly rateType: Rate
}
